import type { Middleware } from 'redux';

import { getPerfDebugLogsState, reducer, setPerfDebugLogsState } from './state';

export const perfDebugLogsMiddleware: Middleware = () => (next) => (action) => {
  setPerfDebugLogsState(reducer(getPerfDebugLogsState(), action));

  return next(action);
};
